// import React from "react";
// import {
//   Paper,
//   Box,
//   Typography,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   useTheme,
//   alpha,
//   Fade,
//   Divider
// } from "@mui/material";
// import {
//   Schedule as ScheduleIcon,
//   Chat as ChatIcon,
//   Payment as PaymentIcon,
//   PhotoCamera as PhotoIcon,
//   Star as StarIcon,
//   Checklist as ChecklistIcon,
//   ArrowForward as ArrowIcon
// } from "@mui/icons-material";
// import { Link } from "react-router-dom";

// const FeaturesMenu = ({ open, anchorEl, onClose }) => {
//   const theme = useTheme();

//   const features = [
//     {
//       icon: <ScheduleIcon />,
//       title: "Automatic Scheduling",
//       description: "Sync with Airbnb calendar",
//       path: "/features/automatic-scheduling"
//     },
//     {
//       icon: <ChatIcon />,
//       title: "In-App Messaging",
//       description: "Direct communication",
//       path: "/features/in-app-messaging"
//     },
//     {
//       icon: <PaymentIcon />,
//       title: "Auto Payment",
//       description: "Secure automated payments",
//       path: "/features/auto-payment"
//     },
//     {
//       icon: <PhotoIcon />,
//       title: "Before & After Photos",
//       description: "Visual proof of quality",
//       path: "/features/before-after-photos"
//     },
//     {
//       icon: <StarIcon />,
//       title: "Cleanliness Score",
//       description: "AI-powered quality control",
//       path: "/features/cleanliness-score"
//     },
//     {
//       icon: <ChecklistIcon />,
//       title: "Task Checklist",
//       description: "Customizable checklists",
//       path: "/features/task-checklist"
//     }
//   ];

//   if (!open) return null;

//   const anchorRect = anchorEl?.getBoundingClientRect();

//   return (
//     <Fade in={open}>
//       <Paper
//         elevation={8}
//         sx={{
//           position: "fixed",
//           top: anchorRect ? anchorRect.bottom + 8 : 64,
//           left: anchorRect ? anchorRect.left : 0,
//           minWidth: 300,
//           maxWidth: 350,
//           background: theme.palette.background.paper,
//           borderRadius: 2,
//           border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//           zIndex: 1300,
//           overflow: "hidden"
//         }}
//       >
//         {/* Header */}
//         <Box sx={{ p: 2, borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}` }}>
//           <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary}>
//             Features
//           </Typography>
//           <Typography variant="body2" color={theme.palette.text.secondary}>
//             Everything you need to manage cleanings
//           </Typography>
//         </Box>

//         {/* Features List */}
//         <List sx={{ p: 1 }}>
//           {features.map((feature, index) => (
//             <ListItem
//               key={index}
//               component={Link}
//               to={feature.path}
//               onClick={onClose}
//               sx={{
//                 borderRadius: 1,
//                 mb: 0.5,
//                 color: 'inherit',
//                 textDecoration: 'none',
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   background: alpha(theme.palette.primary.main, 0.08),
//                   transform: 'translateX(4px)'
//                 },
//                 '&:last-child': {
//                   mb: 0
//                 }
//               }}
//             >
//               <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
//                 {feature.icon}
//               </ListItemIcon>
//               <ListItemText
//                 primary={
//                   <Typography variant="body1" fontWeight="500">
//                     {feature.title}
//                   </Typography>
//                 }
//                 secondary={
//                   <Typography variant="body2" color={theme.palette.text.secondary}>
//                     {feature.description}
//                   </Typography>
//                 }
//               />
//               <ArrowIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
//             </ListItem>
//           ))}
//         </List>

//         {/* Footer */}
//         <Box sx={{ p: 2, borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`, textAlign: 'center' }}>
//           <Typography variant="body2" color={theme.palette.text.secondary}>
//             Need help choosing?{" "}
//             <Typography
//               component="span"
//               variant="body2"
//               sx={{
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 '&:hover': {
//                   textDecoration: 'underline'
//                 }
//               }}
//               onClick={() => {
//                 onClose();
//                 window.location.href = '/contact';
//               }}
//             >
//               Contact us
//             </Typography>
//           </Typography>
//         </Box>
//       </Paper>
//     </Fade>
//   );
// };

// export default FeaturesMenu;



import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Paper, 
  Divider, 
  Button,
  alpha,
  useTheme
} from '@mui/material';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import MessageIcon from '@mui/icons-material/Message';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import WarningIcon from '@mui/icons-material/Warning';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const FeaturesMenuContent = ({ onItemClick, onClose }) => {
  const theme = useTheme();

  const mainFeatures = [
    { 
      icon: <PriceChangeIcon />, 
      title: "Set Your Own Price", 
      description: "Control cleaning fees per property. Maximize revenue.",
      path: "/features/set-your-price",
      color: "#43e97b",
      popular: true
    },
    { 
      icon: <PersonAddIcon />, 
      title: "Bring Your Cleaner", 
      description: "Keep your trusted team. Invite them in seconds.",
      path: "/features/bring-your-cleaner",
      color: "#f093fb",
      popular: true
    },
    { 
      icon: <ScheduleIcon />, 
      title: "Smart Scheduling", 
      description: "Auto-schedule cleanings after every checkout.",
      path: "/features/smart-scheduling",
      color: "#667eea",
    },
    { 
      icon: <ChecklistIcon />, 
      title: "Custom Checklist", 
      description: "Room-by-room cleaning standards with photo verification.",
      path: "/features/custom-checklist",
      color: "#764ba2",
    },
    { 
      icon: <PhotoCameraIcon />, 
      title: "Photo Verification", 
      description: "Time-stamped before/after photos. Perfect for remote hosts.",
      path: "/features/photo-verification",
      color: "#f5576c",
    },
    { 
      icon: <WarningIcon />, 
      title: "Incident Report", 
      description: "Document damage instantly. Airbnb-ready reports.",
      path: "/features/incident-report",
      color: "#ff6b6b",
    },
    { 
      icon: <MessageIcon />, 
      title: "In-App Messaging", 
      description: "Chat with cleaners, share access codes, resolve issues fast.",
      path: "/features/in-app-messaging",
      color: "#4facfe",
    },
    { 
      icon: <DashboardIcon />, 
      title: "Multi-Property Dashboard", 
      description: "Manage all properties from one central hub.",
      path: "/features/multi-property-dashboard",
      color: "#fa709a",
    },
    { 
      icon: <PaymentIcon />, 
      title: "Flexible Payouts", 
      description: "Instant, weekly, or monthly. Pay cleaners your way.",
      path: "/features/flexible-payouts",
      color: "#a8edea",
    },
  ];

  return (
    <Box sx={{ p: 2, width: 800, maxWidth: '90vw' }}>
      <Grid container>
        {/* Main Features Grid */}
        <Grid item xs={12} md={8}>
          <Box sx={{ p: 1 }}>
            <Typography variant="subtitle2" color="primary.main" sx={{ mb: 2, fontWeight: 600, letterSpacing: 1 }}>
              FEATURES
            </Typography>
            <Grid container spacing={1.5}>
              {mainFeatures.map((feature, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Button
                    fullWidth
                    onClick={() => onItemClick(feature.path)}
                    sx={{
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      p: 1.5,
                      borderRadius: 2,
                      textTransform: 'none',
                      color: theme.palette.text.primary,
                      '&:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.05),
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        bgcolor: alpha(feature.color, 0.1),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 1.5,
                        color: feature.color,
                      }}
                    >
                      {React.cloneElement(feature.icon, { sx: { fontSize: 22 } })}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" fontWeight={700}>
                          {feature.title}
                        </Typography>
                        {feature.popular && (
                          <Box
                            sx={{
                              fontSize: '0.65rem',
                              bgcolor: alpha(theme.palette.success.main, 0.1),
                              color: theme.palette.success.main,
                              px: 0.8,
                              py: 0.3,
                              borderRadius: 2,
                              fontWeight: 600,
                            }}
                          >
                            POPULAR
                          </Box>
                        )}
                      </Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                        {feature.description}
                      </Typography>
                    </Box>
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        {/* Right Side - CTA Section */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              bgcolor: alpha(theme.palette.primary.main, 0.02),
              borderRadius: 2,
              height: '100%',
            }}
          >
            <Typography variant="subtitle2" color="primary.main" sx={{ mb: 2, fontWeight: 600, letterSpacing: 1 }}>
              RESOURCES
            </Typography>
            
            <Button
              fullWidth
              component={Link}
              to="/features"
              onClick={onClose}
              sx={{
                justifyContent: 'space-between',
                p: 1.5,
                mb: 1,
                borderRadius: 2,
                textTransform: 'none',
                color: theme.palette.text.primary,
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) },
              }}
            >
              <Typography variant="body2" fontWeight={500}>All Features Overview</Typography>
              <ArrowForwardIcon sx={{ fontSize: 18 }} />
            </Button>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" color="primary.main" sx={{ mb: 2, fontWeight: 600, letterSpacing: 1 }}>
              WHY FRESHSWEEPER
            </Typography>
            
            <Box sx={{ mb: 2 }}>
              {[
                "Keep your existing cleaners",
                "Set your own cleaning fees",
                "Automated scheduling",
                "Photo verification",
                "24/7 support",
              ].map((item, idx) => (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <CheckCircleIcon sx={{ fontSize: 14, color: theme.palette.success.main }} />
                  <Typography variant="caption">{item}</Typography>
                </Box>
              ))}
            </Box>

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
              }}
              onClick={() => onItemClick('/contact')}
            >
              Start Free Trial
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeaturesMenuContent;